import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import References from './pages/References';
import ReferenceDetail from './pages/ReferenceDetail';
import Contact from './pages/Contact';
import About from './pages/About';
import Cases from './pages/Cases';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Forbidden from './pages/Forbidden';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <div className="flex flex-col min-h-screen bg-surface text-primary antialiased">
      <ScrollToTop />
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          {/* Support both site-office and site-offices, and vaskeri-laundry slugs */}
          <Route path="/services/site-office" element={<ServiceDetail />} />
          <Route path="/services/site-offices" element={<ServiceDetail />} />
          <Route path="/services/vaskeri-laundry" element={<ServiceDetail />} />
          <Route path="/references" element={<References />} />
          <Route path="/references/:slug" element={<ReferenceDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/cases" element={<Cases />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/403" element={<Forbidden />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
